var InteractiveParameterElementAndInteractiveParameterCommonMethods = require('./InteractiveParameterElementAndInteractiveParameterCommonMethods'),
    InteractiveParameterElement = require('./InteractiveParameterElement');

/**
 * Параметры конструктора InteractiveParameter
 * @typedef {Object} InteractiveParameterConstructorParams
 * @property {string} selector - Селектор параметра
 * @property {string} indexBy - jQuery-инструкция, применяемая к элементу, определяющая индекс элемента
 * @property {string} [classActive] - Класс активного элемента
 * @property {string} [classHidden] - Класс скрытого элемента. Если не указан, используется механизм скрывания/показывания jQuery
 * @property {string} [disabledCursor] - Указатель недоступного элемента
 * @property {Function} [init] - Действия для полной инициализации параметра
 * @property {Function} [onClick] - Обработка нажатия на элемент
 * @property {InteractiveParametersGroup} [InteractiveParametersGroup] - Объект группы интерактивных параметров
 */

/**
 * Интерактивный параметр
 * @param {InteractiveParameterConstructorParams} params
 * @constructor
 */
function InteractiveParameter(params) {
    /**
     * Инициализирован ли параметр
     * @type {boolean}
     */
    this.initialized = !params.init;
    /**
     * Собственная инициализация
     * @type {Function}
     * @param {boolean} [applyToRelated] - Пометить ли связанные параметры как инициализированные
     * @this {InteractiveParameter}
     */
    this.init = function (applyToRelated) {
        if (params.init) {
            params.init.apply(this);
        }
        if (applyToRelated) {
            this.applyToSelfAndRelated('getInitialized');
        } else {
            this.getInitialized();
        }
    }.bind(this);
    /**
     * Связанные объекты InteractiveParameter
     * @type {InteractiveParameter[]}
     */
    this.related = [];
    /**
     * Элементы параметра
     * @type {Object.<string, InteractiveParameterElement>}
     */
    this.elements = {};
    /**
     * Текущий активный элемент
     * @type {InteractiveParameterElement|null}
     */
    this.active = null;
    /**
     * Объект InteractiveParametersGroup параметра
     * @type {InteractiveParametersGroup|null}
     */
    this.InteractiveParametersGroup = params.InteractiveParametersGroup || null;
    /**
     * Селектор элементов
     * @type {string}
     */
    this.selector = params.selector;

    // Определение элементов
    var self = this;
    var $elements = $(this.selector).each(function () {
        var $element = $(this),
            elementIndex = eval("$element." + params.indexBy);
        self.elements[elementIndex] =
            new InteractiveParameterElement({
                $element: $(this),
                classActive: params.classActive,
                classHidden: params.classHidden,
                disabledCursor: params.disabledCursor,
                onClick: params.onClick,
                index: elementIndex,
                InteractiveParameter: self
            });
    });

    /**
     * Количество элементов параметра
     * @type {number}
     */
    this.elementsCount = $elements.length;
}

InteractiveParameter.prototype = {
    /**
     * Метод связывает данный параметр и переданный, связывает элементы параметров
     * @param {InteractiveParameter} InteractiveParameter
     * @param {boolean} [elementsRelated] - Связаны ли элементы. При true элементы не связываются
     */
    relateWith: function (InteractiveParameter, elementsRelated) {
        if (InteractiveParameter !== this) {
            if (this.related.indexOf(InteractiveParameter) === -1) {
                if (!elementsRelated) {
                    for (var elementIndex in this.elements) {
                        if (InteractiveParameter.elements[elementIndex]) {
                            InteractiveParameter.elements[elementIndex].relateWith(this.elements[elementIndex]);
                        }
                    }
                }
                this.related.push(InteractiveParameter);
                InteractiveParameter.relateWith(this, true);
            }
        }
    },
    /**
     * Метод делает параметр инициализированным
     */
    getInitialized: function () {
        if (!this.initialized) {
            this.initialized = true;
        }
    },
    /**
     * Метод определяет, является ли элемент по индексу активным
     * @param {*} index
     * @returns {boolean|null} - Возврашает null, если элемента нет
     */
    isActive: function (index) {
        if (this.elements[index]) {
            return this.elements[index] === this.active;
        }
        return null;
    },
    /**
     * Метод делает элемент по индексу активным
     * @param {*} index
     * @returns {boolean}
     */
    makeActive: function (index) {
        if (this.elements[index]) {
            this.elements[index].getActive();
            this.active = this.elements[index];
            return true;
        }
        return false;
    },
    /**
     * Метод делает элемент по индексу единственно активным
     * @param {*} index
     */
    makeOnlyActive: function (index) {
        if (this.makeActive(index)) {
            for (var elementIndex in this.elements) {
                if (index != elementIndex) {
                    this.elements[elementIndex].getInactive();
                }
            }
        }
    },
    /**
     * Метод вызывает нажатие на первый элемент
     * @param {boolean} [allowDisabled] - Может ли отрабатывать нажатие для недоступного элемента
     */
    clickFirst: function (allowDisabled) {
        for (var elementIndex in this.elements) {
            if (!this.elements[elementIndex].hidden) {
                this.elements[elementIndex].getClicked(null, allowDisabled);
                break;
            }
        }
    },
    /**
     * Метод делает недоступными все элементы
     */
    disableAll: function () {
        for (var elementIndex in this.elements) {
            this.elements[elementIndex].getDisabled();
        }
    },
    /**
     * Метод делает доступными все элементы
     * @param {Array} [except] - Индексы элементов, которые доступными делать не нужно
     */
    enableAll: function (except) {
        except = except instanceof Array ? except : [];
        for (var elementIndex in this.elements) {
            if (except.indexOf(elementIndex) === -1) {
                this.elements[elementIndex].getEnabled();
            }
        }
    },
    /**
     * Метод определяет, является ли элемент по индексу скрытым
     * @param {*} index
     * @returns {boolean|null} - Возврашает null, если элемента нет
     */
    isHidden: function (index) {
        if (this.elements[index]) {
            return this.elements[index].hidden;
        }
        return null;
    },
    /**
     * Метод определяет количество нескрытых элементов
     * @returns {number}
     */
    getNotHiddenElementsCount: function () {
        var count = 0;
        for (var elementIndex in this.elements) {
            if (!this.elements[elementIndex].hidden) {
                count++;
            }
        }
        return count;
    },
    /**
     * Метод вызывает метод с аргументами у параметра и связанных параметров
     * @type {applyToMethod}
     */
    applyToSelfAndRelated: InteractiveParameterElementAndInteractiveParameterCommonMethods.applyToSelfAndRelated,
    /**
     * Метод вызывает метод с аргументами у связанных параметров
     * @type {applyToMethod}
     */
    applyToRelated: InteractiveParameterElementAndInteractiveParameterCommonMethods.applyToRelated
};

module.exports = InteractiveParameter;



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/module/InteractiveParameter.js